
<template>
	<span :class="['inline-flex rounded-md', {'w-full flex justify-center':full != false, 'shadow-sm':flat==false, 'rounded-full':pill}]" @click="click">
		<button 
		v-if='to == null || (to != null && disabled)' 
		:disabled='disabled || busy' 
		type="button" 
		:class="['tw-button', size, variant, {'w-full flex justify-center':full != false, 'pill':pill}]">
		<i class="fas fa-circle-notch fa-spin mx-2" v-if='busy'></i>
		<slot v-if="(busy == true && busyHideText == false) || busy == false"></slot>
	</button>


	<router-link 
	v-else
	:to='to' 
	:disabled='true' 
	:class="['tw-button', size, variant, {'w-full flex justify-center':full != false, 'pill':pill}]"><slot></slot></router-link>

</span>
</template>

<script>
	
	export default{
		name:'tw-button',
		props:{
			to:{
				default:null,
			},
			variant:{
				type:String,
				default:'primary',
			},
			disabled:{
				type:Boolean,
				default:false
			},
			size:{
				type:String,
				default:'md',
			},
			full:{
				type:Boolean,
				default:false
			},
			flat:{
				type:Boolean,
				default:false
			},
			busy:{
				type:Boolean,
				default:false
			},
			busyHideText:{
				type:Boolean,
				default:false
			},
			pill:{
				type:Boolean,
				default:false
			},
		},
		methods:{
			click(e){
				this.$emit('click', e);
				this.$emit('clicked', e);
			}
		}


	}

</script>